module.exports = __webpack_public_path__ + "images/market/for_business/banner_pc_1fefe687656f37dc70ec43d8155ce57e.png";